import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Icon } from '@qga/roo-ui/components';

const convertToReturning = () => css`
  transform: rotateY(180deg) rotate(-20deg);
`;

const StyledFlightIcon = styled(Icon)`
  transform: rotate(-20deg);
  ${(props) => props.direction === 'returning' && convertToReturning()}
`;

const FlightIcon = (props) => (
  <StyledFlightIcon
    name="flightDeparting"
    color="brand.primary"
    size={[32, null, 36]}
    {...props}
  />
);

FlightIcon.propTypes = StyledFlightIcon.propTypes;

export default FlightIcon;
